import React from "react";
import { Link } from 'react-router-dom';
import { isMobile, isDesktop } from 'react-device-detect';
import '../App.css';

const Footer = () => {
    return ( 
        <nav className="modern-footer" style={{marginBottom: isMobile ? "25px" : ""}}>
            <div className="footer-nav">
                <Link to="/" className="footer-item">
                    <i className="lni lni-home footer-icon"></i>
                    <span className="footer-label">မူလ</span>
                </Link>
                <Link to="/transaction" className="footer-item">
                    <i className="lni lni-wallet footer-icon"></i>
                    <span className="footer-label">ငွေလွှဲ</span>
                </Link>
                <Link to="/currency" className="footer-item">
                    <i className="lni lni-alarm footer-icon"></i>
                    <span className="footer-label">ငွေလွှဲနှုန်း</span>
                </Link>
                <Link to="/profile" className="footer-item">
                    <i className="lni lni-user footer-icon"></i>
                    <span className="footer-label">ကျွန်ုပ်</span>
                </Link>
            </div>
        </nav>
     );
}
 
export default Footer;